import { TravellerData } from "./ExcelUpload.types";

// Error codes for Excel upload operations
export enum ExcelUploadErrorCode {
  FILE_SIZE_EXCEEDED = "FILE_SIZE_EXCEEDED",
  UNSUPPORTED_FILE_TYPE = "UNSUPPORTED_FILE_TYPE",
  UNABLE_TO_READ_FILE = "UNABLE_TO_READ_FILE",
  NO_DETAILS_FOUND = "NO_DETAILS_FOUND",
  FIELDS_MISSING = "FIELDS_MISSING",
  TOO_MANY_ROWS = "TOO_MANY_ROWS",
  FILE_FORMAT_ERROR = "FILE_FORMAT_ERROR",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

// Custom error class with code support
export class ExcelUploadError extends Error {
  code: ExcelUploadErrorCode;
  missingFields?: string[];

  constructor(
    code: ExcelUploadErrorCode,
    message?: string,
    missingFields?: string[]
  ) {
    super(message || code);
    this.code = code;
    this.missingFields = missingFields;
    this.name = "ExcelUploadError";
  }
}

// Expected column headers mapping (case-insensitive)
export const HEADER_MAPPING: Record<string, keyof TravellerData> = {
  name: "name",
  "date of birth (dd/mm/yyyy)": "dob",
  "date of birth": "dob",
  dob: "dob",
  gender: "gender",
  "gender (m/f/o)": "gender",
  "gender (male/female/others)": "gender",
  "passport number": "passport",
  "passport number (optional)": "passport",
  "nominee name": "nomineeName",
  nominee: "nomineeName",
  "nominee name (optional)": "nomineeName",
  "nominee (optional)": "nomineeName",
};

// Gender value mapping (case-insensitive) - maps various inputs to standard values
export const GENDER_VALUE_MAPPING: Record<string, string> = {
  m: "MALE",
  male: "MALE",
  f: "FEMALE",
  female: "FEMALE",
  o: "OTHERS",
  others: "OTHERS",
  other: "OTHERS",
};
